export interface SpinnerProps {
  /** 가운데 정렬(블록) 표시 */
  center?: boolean;
  className?: string;
}

/** 로딩 스피너 */
export default function Spinner({ center = false, className = '' }: SpinnerProps) {
  const classes = ['spinner', center ? 'spinner--center' : '', className].filter(Boolean).join(' ');
  return <span className={classes} role="status" aria-label="로딩 중" />;
}
